import '../lib/typedef';
import Axios from 'axios';
import { buildQuery } from '@/lib/helper';
import client from '@/lib/http-client';

const endpoint = '/logistics';

export default {
	getLogistics(params, cb, errorCb, cancelToken) {
		const url = endpoint;
		client
			.get(url, { params, cancelToken })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (!Axios.isCancel(e)) {
					if (errorCb) errorCb(e);
				}
			});
	},

	/**
	 * Fetch Contact Detail
	 *
 	 * @param {Object} id ID
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	getDetails(id, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client
			.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	store(params, cb, errorCb) {
		const url = endpoint;
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Single Delete Contact
	 *
	 *
	 * @param {Object} id ID
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	delete(id, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client
			.delete(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Bulk Delete Contacts
	 *
	 * @param {Object} params
	 * @param {string[]} params.customer_ids Array of Contacts ID
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	bulkDelete(ids = [], cb, errorCb) {
		const url = endpoint;

		const idsJSON = JSON.stringify(ids);
		const params = {
			customer_ids: idsJSON,
		};

		client
			.delete(url, { data: params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				} else {
					// eslint-disable-next-line
					console.log(e);
				}
			});
	},

	/**
	 * Export Contact
	 *
	 * @param {Object} params
	 * @param {'created_at'} params.sort_by Created By
	 * @param {'desc' | 'asc'} params.sort Sort
	 * @param {string} params.since Date Since
	 * @param {string} params.until Date Until
	 * @param {string} [params.keyword] Search Keyword
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	export(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/export?${query}`;
		client
			.get(url)
			.then((response) => {
				if (cb) {
					cb(response.data);
				}
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				} else {
					// eslint-disable-next-line
					console.log(e);
				}
			});
	},

	/**
	 * Single Update Contact
	 *
	 * @param {string} id Contact ID
	 * @param {Object} params
	 * @param {Object} params.customer_data Customer Data
	 * @param {string} params.customer_data.name Customer Data Name
	 * @param {string} params.customer_data.email Customer Data Email
	 * @param {string} params.customer_data.picture Customer Data Picture
	 * @param {string[]} params.customer_data.tags Customer Data Tag
	 * @param {string} params.customer_data.label Customer Address Label
	 * @param {string} params.customer_data.receiver_name Customer Address Receiver Name
	 * @param {string} params.customer_data.province_id Customer Address Province ID
	 * @param {string} params.customer_data.province_name Customer Address Province Name
	 * @param {string} params.customer_data.city_id Customer Address City ID
	 * @param {string} params.customer_data.city_name Customer Address City Name
	 * @param {string} params.customer_data.city_name_with_type Customer Address City Name With Type
	 * @param {string} params.customer_data.subdistrict_id Customer Address Subdistrict ID
	 * @param {string} params.customer_data.subdistrict_name Customer Address Subdistrict Name
	 * @param {string} params.customer_data.address Customer Address
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	update(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client
			.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Bulk Update Contacts
	 *
	 * @param {Object} params
	 * @param {string[]} params.customer_ids Array of Contacts ID
	 * @param {Object} params.customer_data Customer Data
	 * @param {string} params.customer_data.name Customer Data Name
	 * @param {string} params.customer_data.email Customer Data Email
	 * @param {string} params.customer_data.picture Customer Data Picture
	 * @param {string[]} params.customer_data.tags Customer Data Tag
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	updateBulk(params, cb, errorCb) {
		const url = `${endpoint}/bulk`;
		client
			.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Get Stats
	getStats(params, cb, errorCb) {
		const url = `${endpoint}/stats`;
		client
			.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Logistic search
	 *
	 * @param {Object} params
	 * @param {string} params.receipt_number Receipt Number
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	search(params, cb, errorCb) {
		const url = `${endpoint}/search`;
		client
			.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
};
